export const getGridTemplate = (travelType, travelTypeFieldIncluded = true) => {
  const fieldToggleKeyword = travelTypeFieldIncluded ? 'with' : 'without';
  return `${travelType}-${fieldToggleKeyword}TravelTypeField`;
};